import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import FormNumberInput from "go-form/components/FormNumberInput";
import { EmployeeApi } from "../../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<EmployeeApi>;
}

const EmployeeContactForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		control,
		formState: { errors },
		register,
	} = form;

	return (
		<fieldset className="form-group">
			<legend>
				<h5>
					{t("modules.employee.field.contact.title")}
					<small className="text-muted">
						<br />
						{t("modules.employee.field.contact.help_text.description")}
					</small>
				</h5>
			</legend>
			<div className="row">
				<div className="col-md-6">
					<FormNumberInput
						label={t("common.contact.phone.label")}
						control={control}
						suffix=""
						name="contact_phone_number"
						errors={errors}
					/>
				</div>
				<div className="col-md-6">
					<FormInput
						label={t("common.word.email", { ns: "lib" })}
						register={register}
						name="contact_email"
						errors={errors}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col-md-6">
					<FormInput
						label={t("common.address.city", { ns: "lib" })}
						register={register}
						name="address_city"
						errors={errors}
					/>
				</div>
				<div className="col-md-6">
					<FormInput
						label={t("common.address.zip_code", { ns: "lib" })}
						register={register}
						name="address_zip_code"
						errors={errors}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col-md-6">
					<FormInput
						label={t("common.address.street", { ns: "lib" })}
						register={register}
						name="address_street"
						errors={errors}
					/>
				</div>
				<div className="col-md-6">
					<div className="row">
						<div className="col-md-6">
							<FormInput
								label={t("common.address.build_nr", { ns: "lib" })}
								register={register}
								name="address_build_nr"
								errors={errors}
							/>
						</div>
						<div className="col-md-6">
							<FormInput
								label={t("common.address.flat_nr", { ns: "lib" })}
								register={register}
								name="address_flat_nr"
								errors={errors}
							/>
						</div>
					</div>
				</div>
				<div className="col-md-6">
					<div className="row">
						<div className="col-md-6">
							<FormInput
								label={t("common.address.country", { ns: "lib" })}
								register={register}
								name="address_country"
								errors={errors}
							/>
						</div>
						<div className="col-md-6">
							<FormInput
								label={t("common.contact.others.label")}
								register={register}
								name="contact_other"
								errors={errors}
							/>
						</div>
					</div>
				</div>
			</div>
		</fieldset>
	);
};

export default EmployeeContactForm;
